import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { AutenticacaoService } from './autenticacao.service';

@NgModule({
  imports: [
    CommonModule,
    AppSharedModule,
  ],
  declarations: [],
  providers: [
    AutenticacaoService
  ],
  exports: [],
})
export class AutenticacaoModule { }
